<div class="flex flex-col ui-gap p-5">

  <span class="flex ui-gap">
    <span>Disable buttons </span>&nbsp;&nbsp;
    <p-toggleswitch [(ngModel)]="disabled" onLabel="Disabled" offLabel="Enabled"></p-toggleswitch>
  </span>

  <table class="compare-table">
    <colgroup>
      <col class="col-btn">
      <col class="col-desc">
      <col class="col-source">
    </colgroup>

    <!-- Divider row for Legacy Buttons -->
    <tr class="divider-row">
      <td colspan="3">
        <div class="divider-with-text">
          <hr>
          <span class="divider-text">Legacy Buttons 😔</span>
        </div>
      </td>
    </tr>

    <tr>
      <th>Button</th>
      <th>Description</th>
      <th>Source</th>
    </tr>
    <tr>
      <td>
        <!-- Basic HTML Button -->
        <div class="btn-cell">
          <button [disabled]="disabled" (click)="onButtonClick(0, 'HTML Button')">
            HTML button
          </button>
        </div>
      </td>
      <td>Plain HTML <code>&lt;button&gt;</code> element</td>
      <td>
        <pre class="language-html"><code>&lt;button [disabled]="disabled" (click)=&quot;onButtonClick(0, 'HTML Button')&quot;&gt;HTML button&lt;/button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- Angular Material Flat Button -->
        <div class="btn-cell">
          <button mat-flat-button [disabled]="disabled" (click)="onButtonClick(1, 'Mat Flat Button')">
            mat-flat-button
          </button>
        </div>
      </td>
      <td>Angular Material <code>mat-flat-button</code> directive</td>
      <td>
        <pre class="language-html"><code>&lt;button mat-flat-button [disabled]="disabled" (click)=&quot;onButtonClick(1, 'Mat Flat Button')&quot;&gt;mat-flat-button&lt;/button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- PrimeNG Button -->
        <div class="btn-cell">
          <p-button [disabled]="disabled" (click)="onButtonClick(2, 'PrimeNG Button')">
            PrimeNG button
          </p-button>
        </div>
      </td>
      <td>PrimeNG <code>p-button</code> component</td>
      <td>
        <pre class="language-html"><code>&lt;p-button [disabled]="disabled" (click)=&quot;onButtonClick(2, 'PrimeNG Button')&quot;&gt;PrimeNG button&lt;/p-button&gt;</code></pre>
      </td>
    </tr>

    <!-- Divider row with optional text -->
    <tr class="divider-row">
      <td colspan="3">
        <div class="divider-with-text">
          <hr>
          <span class="divider-text">EZ Buttons 😊</span>
        </div>
        <p>
        EZ Buttons can be coded just like plain HTML buttons. They handle [disabled] and (click) the same as native buttons. They can also be configured with a [config] object.
        EZ Buttons will automatically render as an &lt;a> tag if the [href] or [routerLink] property is specified, otherwise it will render as a &lt;button>.
        The &lt;a> tag is used for links so that the target URL shows up in the browser's status bar.
        </p>
      </td>
    </tr>

    <tr>
      <td>
        <!-- EZ Button -->
        <div class="btn-cell">
          <ui-button [disabled]="disabled" (click)="onButtonClick(3, 'EZ Button')">
            EZ Button
          </ui-button>
        </div>
      </td>
      <td>EZ Button (default)</td>
      <td>
        <pre class="language-html"><code>&lt;ez-button [disabled]="disabled" (click)=&quot;onButtonClick(3, 'EZ Button')&quot;&gt;EZ Button&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- EZ Button Secondary -->
        <div class="btn-cell">
          <ui-button
            severity="secondary"
            [disabled]="disabled"
            (click)="onButtonClick(11, 'EZ Button Secondary')"
            [badgeValue]="badgeValue"
          >
            EZ Button (secondary)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="secondary"</code> and a dynamic badgeValue</td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="secondary" [disabled]="disabled" (click)="onButtonClick(11, 'EZ Button Secondary')" [badgeValue]="badgeValue"&gt;EZ Button (secondary)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- EZ Button Small -->
        <div class="btn-cell">
          <ui-button size="small" [disabled]="disabled" (click)="onButtonClick(4, 'EZ Button Small')">
            EZ Button (small)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>size="small"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button size="small" [disabled]="disabled" (click)=&quot;onButtonClick(4, 'EZ Button Small')&quot;&gt;EZ Button (small)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- EZ Button large -->
        <div class="btn-cell">
          <ui-button size="large" [disabled]="disabled" (click)="onButtonClick(4.5, 'EZ Button Large')">
            EZ Button (large)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>size="small"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button size="large" [disabled]="disabled" (click)=&quot;onButtonClick(4.5, 'EZ Button Small')&quot;&gt;EZ Button (large)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <!-- EZ Button Contrast -->
        <div class="btn-cell">
          <ui-button severity="contrast" [disabled]="disabled" (click)="onButtonClick(5, 'EZ Button Contrast')">
            EZ Button (contrast)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="contrast"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="contrast" [disabled]="disabled" (click)="onButtonClick(5, 'EZ Button Contrast')"&gt;EZ Button (contrast)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <div class="btn-cell">
          <ui-button containerClass="close-button" [disabled]="disabled" (click)="onButtonClick(7, 'EZ Button Close')">
            EZ Button (close)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>containerClass="close-button"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button containerClass="close-button" [disabled]="disabled" (click)="onButtonClick(7, 'EZ Button Close')"&gt;EZ Button (close)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>

    <tr>
      <td>
        <div class="btn-cell">
          <ui-button pIcon="pi-refresh" (click)="onButtonClick(8, 'EZ Button Prime Icon')" containerClass="refresh" />
        </div>
      </td>
      <td>EZ Button with PrimeNG Icon</td>
      <td>
        <pre class="language-html"><code>&lt;ez-button pIcon="pi-refresh" (click)="onButtonClick(8, 'EZ Button Prime Icon')" /&gt;</code></pre>
      </td>
    </tr>

    <!-- New divider row for unused variants -->
    <tr class="divider-row">
      <td colspan="3">
        <div class="divider-with-text">
          <hr>
          <span class="divider-text">Variants we don't use (yet?) 🤔</span>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <!-- EZ Button Danger -->
        <div class="btn-cell">
          <ui-button severity="danger" [disabled]="disabled" (click)="onButtonClick(6, 'EZ Button Danger')">
            EZ Button (danger)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="danger"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="danger" [disabled]="disabled" (click)=&quot;onButtonClick(6, 'EZ Button Danger')&quot;&gt;EZ Button (danger)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <div class="btn-cell">
          <ui-button severity="success" [disabled]="disabled" (click)="onButtonClick(8, 'EZ Button Success')">
            EZ Button (success)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="success"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="success" [disabled]="disabled" (click)="onButtonClick(8, 'EZ Button Success')"&gt;EZ Button (success)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <div class="btn-cell">
          <ui-button severity="info" [disabled]="disabled" (click)="onButtonClick(9, 'EZ Button Info')">
            EZ Button (info)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="info"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="info" [disabled]="disabled" (click)="onButtonClick(9, 'EZ Button Info')"&gt;EZ Button (info)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
    <tr>
      <td>
        <div class="btn-cell">
          <ui-button severity="warn" [disabled]="disabled" (click)="onButtonClick(10, 'EZ Button Warn')">
            EZ Button (warn)
          </ui-button>
        </div>
      </td>
      <td>EZ Button with <code>severity="warn"</code></td>
      <td>
        <pre class="language-html"><code>&lt;ez-button severity="warn" [disabled]="disabled" (click)="onButtonClick(10, 'EZ Button Warn')"&gt;EZ Button (warn)&lt;/ez-button&gt;</code></pre>
      </td>
    </tr>
  </table>
</div>
<p-toast
  key="button-toast"
  position="center"
  styleClass="custom-toast"
></p-toast>


